import { WarehouseStationaryIcon } from '@/modules/warehouses/icons/types.icons';
import { WarehouseSleeveList } from '@/shared/ui/icons';
import styles from './index.module.sass';
import stationary from '@@/mixing/images/stationary.svg';
import sleeve from '@@/mixing/images/sleeve.svg';
import { Tooltip } from 'antd';
import { useWindowDimensions } from '@/modules/common/hooks/use-window-dimensions.hook';
import { RubleRegular } from '@/modules/common/components/ruble-regular';

export const SidebarItem = ({
  id,
  title,
  profit,
  selected,
  onClick,
  onPriceClick,
  type,
}: IArgs) => {
  const { width } = useWindowDimensions();
  console.log(profit.toFixed(0));
  return width > 1265 ? (
    <Tooltip
      color="#fff"
      overlayInnerStyle={{ color: '#000' }}
      title={`id склада: ${id}`}
      placement="right"
    >
      <div
        className={styles.root}
        aria-selected={selected}
        aria-positive={profit >= 1}
        onClick={onClick}
      >
        <img className={styles.icon} src={type === '1' ? stationary : sleeve} />
        <span className={styles.label}>{title}</span>
        <span className={styles.profit} onClick={onPriceClick}>
          + {Math.round(profit).toLocaleString('ru')} <RubleRegular p={0} />
        </span>
      </div>
    </Tooltip>
  ) : (
    <div
      className={styles.root}
      aria-selected={selected}
      aria-positive={profit > 0}
      onClick={onClick}
    >
      <img className={styles.icon} src={type === '1' ? stationary : sleeve} />
      <span className={styles.label}>{title}</span>
      <span className={styles.profit} onClick={onPriceClick}>
        + {Math.round(profit).toLocaleString('ru')} ₽
      </span>
    </div>
  );
};

interface IArgs {
  id: number;
  title: string;
  profit: number;
  selected: boolean;
  onClick: () => void;
  onPriceClick: () => void;
  type: '1' | '2';
}
